export default "__VITE_PUBLIC_ASSET__c56c1251__"